import React from "react";
import PropTypes from "prop-types";
//import {Outcome} from '../Outcome';
import "./style.scss";

export function JointNode(props) {
  const getIsCorrect = (c) => c.answerId.includes(c.droppedId);

  const getFeedback = (c, isCorrect) => {
    if (isCorrect) return "";
    else return c.feedbackMessage;
  };

  const getIsEmpty = (c) => c.droppedId === null;

  const onDropStep = (positionId) =>
    React.useCallback((params) => {
      props.onDropStep({ ...params, positionId, nodeId: props.nodeId });
    }, []);

  const onRemoveStep = (positionId) =>
    React.useCallback(() => {
      props.onRemoveStep({ positionId, nodeId: props.nodeId });
    }, []);

  const outcomeComponent = (nodeComponent) => {
    const isCorrect = getIsCorrect(nodeComponent);
    return React.createElement(props.outcomeNode, {
      key: nodeComponent.id,
      isCorrect,
      tabIndex: props.tabIndex,
      ...props.outcomeNode.props,
      title: nodeComponent.title,
      image: nodeComponent.image,
      isEmpty: getIsEmpty(nodeComponent),
      droppedId: nodeComponent.droppedId,
      onDrop: onDropStep(nodeComponent.id),
      showTooltip: nodeComponent.showTooltip,
      placeHolder: nodeComponent.placeHolder,
      onRemove: onRemoveStep(nodeComponent.id),
      feedbackMessage: getFeedback(nodeComponent, isCorrect),
    });
  };

  let className = "design-view__jointNode";

  const totalNodeComponents = props.nodeComponents.length;

  if (totalNodeComponents >= 2) {
    className += " jointNode--2";
  }

  return (
    <div className={className}>
      {props.nodeComponents.map(outcomeComponent)}
    </div>
  );
}

JointNode.propTypes = {
  /**
   * List of Components too display in Node
   */
  nodeComponents: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Uniqe id of component
       */
      id: PropTypes.number,
      /**
       * Type of NodeComponent
       */
      type: PropTypes.oneOf(["OUTCOME_CARD"]),
      /**
       * Title of OutcomeNode
       */
      title: PropTypes.string,
      /**
       * Image URL for OutcomeNode
       */
      image: PropTypes.string,
      /**
       * Placeholder text when no Node is dropped
       */
      placeHolder: PropTypes.string,
      /**
       * Feedback message
       */
      feedbackMessage: PropTypes.string,
      /**
       * List of Ids' of Node/Component that are correct for the spot
       */
      answerId: PropTypes.arrayOf(PropTypes.number),
      /**
       * UniqueId of option dropped in the node
       */
      droppedId: PropTypes.number,
    })
  ),
  /**
   * React Component to be used as Outcome Component
   */
  outcomeNode: PropTypes.elementType,
  /**
   * Function for when an Option in dropped in Node
   */
  onDropStep: PropTypes.func,
  /**
   * Function for when a Step is removed from Node
   */
  onRemoveStep: PropTypes.func,
};

JointNode.defaultProps = {
  nodeComponents: [],
};
